<ng-container>
  <app-modal-header [automaticClose]="false" (closeEvent)="onCloseModal()" class="border-b-2 border-theme-500">
    <div class="flex items-center">
      <svg-icon class="hidden w-24 md:block" src="assets/images/logos/logo-eclass.svg"></svg-icon>
      <hr app-modal-divider class="hidden md:block" />
      <h1 translate class="text-lg text-gray-500">eclass.importar-trilhas.importar-trilhas</h1>
    </div>
  </app-modal-header>
  <div app-modal-content class="h-[80vh] w-[95vw] rounded-b-3xl! p-0! pb-5!">
    <div class="flex flex-col justify-start gap-2 md:flex-row md:justify-between">
      <div class="h-[40vh] w-full overflow-y-auto bg-gray-100 p-5 shadow md:h-[80vh] md:w-1/2 md:rounded-bl-3xl">
        <div [formGroup]="form" class="mb-6 flex w-full flex-row gap-8 rounded-lg bg-white p-5 shadow">
          <app-form-field class="w-full">
            <label translate app-label>eclass.importar-trilhas.colecoes</label>
            <ng-select
              app-select
              formControlName="collection"
              [items]="collections$ | async"
              bindLabel="nome"
              bindValue="id"
              placeholder="Selecione uma coleção"
              [clearable]="false"
              [loading]="loadingCollections$ | async"
            ></ng-select>
          </app-form-field>
          <app-form-field class="w-full">
            <label translate app-label>eclass.importar-trilhas.cursos</label>
            <input app-input type="text" placeholder="Pesquisar cursos da coleção" />
          </app-form-field>
        </div>
        <app-accordion class="w-full">
          @if (courses$ | async; as cursos) {
            @for (curso of cursos; track curso) {
              <div>
                <app-accordion-item>
                  <div app-accordion-header class="flex items-center justify-start gap-4" translate>
                    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-gray-300">
                      <img
                        app-img
                        class="h-12 w-12 select-none rounded-lg"
                        [src]="curso.thumbnail"
                        onerror="src='assets/images/default.png'"
                      />
                    </div>
                    <div class="text-lg font-medium text-theme-600">{{ curso.titulo }}</div>
                  </div>
                  <div app-accordion-content class="rounded-lg bg-linear-to-r from-white via-theme-50 to-theme-100">
                    <app-accordion class="relative w-full">
                      <div class="absolute left-[4%] h-full border border-l border-theme-500 opacity-70"></div>
                      @if (curso.subdivisoes) {
                        @for (subdivision of curso.subdivisoes; track subdivision) {
                          <div class="flex flex-col items-end justify-center">
                            <app-card-subdivision
                              class="relative w-11/12"
                              [subdivision]="subdivision"
                            ></app-card-subdivision>
                          </div>
                        }
                      }
                      @if (curso.trilhas) {
                        @for (trail of curso.trilhas; track trail) {
                          <div class="flex flex-col items-end justify-center">
                            <app-card-trail class="relative w-11/12" [trail]="trail"></app-card-trail>
                          </div>
                        }
                      }
                    </app-accordion>
                  </div>
                </app-accordion-item>
              </div>
            }
          } @else {
            <app-card>
              <div app-card-content class="h-[200px]">
                @if (loadingCourses$ | async) {
                  <app-skeleton></app-skeleton>
                } @else {
                  <app-jumbotron>Selecione uma coleção</app-jumbotron>
                }
              </div>
            </app-card>
          }
        </app-accordion>
      </div>
      <div class="h-[40vh] w-full overflow-y-auto md:h-[80vh] md:w-1/2 md:rounded-br-3xl">
        <div class="flex min-h-full flex-col shadow">
          @if (modalAddTrailService.elementSelected$ | async; as elemento) {
            <div class="flex-1 bg-base-whisper-500 px-6 pb-5! pt-4">
              <div class="flex flex-col items-start justify-center gap-2 pb-4">
                <div class="flex items-center justify-start gap-2">
                  <svg-icon
                    class="flex w-6 text-theme-500"
                    [src]="'assets/icons/' + typeIcon(elemento.tipo)"
                  ></svg-icon>
                  <div class="pl-2 text-2xl">{{ elemento.titulo }}</div>
                  <div class="ml-2 text-md text-theme-900">{{ elemento.sessao.titulo }}</div>
                </div>
              </div>
              <div class="mb-2 w-full">
                @switch (elemento.tipo) {
                  @case ('audio') {
                    <app-audio-card [element]="elemento" [fullSize]="true" [paddingBottom]="true"></app-audio-card>
                  }
                  @case ('avaliacao') {
                    <app-test-card
                      [element]="elemento"
                      [fullSize]="true"
                      [paddingBottom]="true"
                      [preview]="true"
                    ></app-test-card>
                  }
                  @case ('flip') {
                    <app-flip-card [element]="elemento" [fullSize]="true"></app-flip-card>
                  }
                  @case ('imagem') {
                    <app-image-card [element]="elemento" [fullSize]="true"></app-image-card>
                  }
                  @case ('link') {
                    <app-link-card [element]="elemento" [fullSize]="true" [paddingBottom]="true"></app-link-card>
                  }
                  @case ('texto') {
                    <div class="w-full rounded-2xl bg-white p-10 shadow-xl" [innerHTML]="elemento.conteudo"></div>
                  }
                  @case ('video') {
                    <app-video-card [element]="elemento" [fullSize]="true"></app-video-card>
                  }
                }
              </div>
              @if (!!elemento.anexos?.length) {
                <div class="mt-4 w-full rounded-2xl bg-white p-10 shadow-xl">
                  <div class="flex items-center justify-between">
                    <div class="text-lg text-theme-900">Anexos</div>
                  </div>
                  <hr class="-mx-4! mb-3!" app-divider />
                  <div class="h-auto overflow-y-auto 3xl:h-[45rem]">
                    <div class="flex w-full flex-col gap-3 pb-10">
                      @for (annex of elemento.anexos; track annex) {
                        <div
                          class="flex cursor-pointer items-center justify-between gap-2 overflow-y-auto rounded-lg bg-[#fcfcfc] p-2 shadow-md"
                        >
                          <div class="h-16 w-16 rounded-full p-4 shadow-inner">
                            <svg-icon [src]="'/assets/images/files/' + annex.extensao + '.svg'"> </svg-icon>
                          </div>
                          <div class="ml-5 flex w-full flex-col items-start justify-start py-2 lg:ml-0 lg:py-0">
                            <p class="wrap-break-word text-base font-semibold">
                              {{ annex.nome_arquivo }}
                            </p>
                            <p class="text-theme-400">{{ annex.extensao }}</p>
                          </div>
                          <button
                            type="button"
                            app-icon-button
                            (click)="onOpenAnnex(annex)"
                            class="mx-2 flex justify-between"
                          >
                            <svg-icon
                              class="w-6 text-theme-500 hover:text-theme-700"
                              src="assets/icons/icon-view.svg"
                            ></svg-icon>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div app-card-content class="h-[35vh] pr-7 md:h-[80vh]">
              <app-jumbotron translate class="py-8">eclass.importar-trilhas.sem-elementos</app-jumbotron>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div app-modal-footer class="flex-col-reverse md:flex-row md:justify-between">
    <div class="flex w-full flex-col-reverse items-center gap-4 pr-14 md:flex-row md:justify-between">
      <button
        app-outline-button
        (click)="onCloseModal()"
        class="h-fit w-48 border-theme-500 uppercase text-theme-500 hover:bg-theme-500 hover:text-theme-contrast"
        type="button"
      >
        {{ 'geral.cancelar' | translate }}
      </button>
      <div class="flex w-full justify-center gap-6 md:w-fit md:justify-between">
        @if (modalAddTrailService.selectedElements$ | async; as elements) {
          <button
            app-icon-button
            (click)="onSave(elements)"
            type="button"
            class="w-48 gap-3 bg-theme-500 uppercase text-theme-contrast"
          >
            {{ 'geral.salvar' | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</ng-container>
